export default "__VITE_ASSET__Gw7ajkWv__"